import React from 'react';
import styled from '@emotion/styled';
import { Flex } from '../Rebass';
import Logo from '../Logo';
import theme from '../../theme';
import { SxStyleProp } from '../Rebass/types';

interface HeaderProps {
  bg?: string;
  logoColor?: string;
  secondaryButtonColor?: string;
  renderButton?: (colorScheme: string) => React.ReactNode;
  homeLink?: any;
  sx?: SxStyleProp;
}

const StyledIconLabel = styled.span`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

const StyledHeader = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: ${theme.space[4]}px;
  padding-right: ${theme.space[4]}px;
`;

const Header = React.forwardRef<HTMLDivElement, HeaderProps>(
  (
    {
      bg,
      homeLink,
      renderButton,
      logoColor = 'white',
      secondaryButtonColor,
      sx,
    }: HeaderProps,
    ref,
  ) => {
    return (
      <StyledHeader
        ref={ref}
        bg={bg}
        justifyContent="center"
        alignItems="center"
        py={[2]}
        sx={sx}
      >
        <Flex flex="0 1 auto" mr={[3]} {...homeLink}>
          {/* Accessibility purposes (Icons hidden from screen) */}
          <StyledIconLabel className="visually-hidden">
            Singita Home
          </StyledIconLabel>
          <Logo color={logoColor} />
        </Flex>
        {renderButton && renderButton(secondaryButtonColor)}
      </StyledHeader>
    );
  },
);

export default Header;
